module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "归属方:"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentStyle
    },
    model: {
      value: (_vm.form.AgentStyle),
      callback: function($$v) {
        _vm.$set(_vm.form, "AgentStyle", $$v)
      },
      expression: "form.AgentStyle"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("代理商")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("业务员")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": '所属' + _vm.labelName + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择" + _vm._s(_vm.labelName))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐:"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((_vm.orderPackages), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.label
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付对象:"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.form.PayObject),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayObject", $$v)
      },
      expression: "form.PayObject"
    }
  }, [_vm._v("园所")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.form.PayObject),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayObject", $$v)
      },
      expression: "form.PayObject"
    }
  }, [_vm._v("代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": _vm.minNum
    },
    on: {
      "change": _vm.changeNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.openClassList), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '班级' + (index + 1)
      }
    }, [_c('el-select', {
      staticClass: "formlength",
      attrs: {
        "placeholder": "-请选择-"
      },
      model: {
        value: (item.ClassId),
        callback: function($$v) {
          _vm.$set(item, "ClassId", $$v)
        },
        expression: "item.ClassId"
      }
    }, _vm._l((item.ClassLists), function(option) {
      return _c('el-option', {
        key: option.ClassId,
        attrs: {
          "value": option.ClassId,
          "label": option.ClassName
        }
      })
    })), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0),
        expression: "index==0"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": _vm.addClass
      }
    }, [_vm._v("创建班级")])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "暑期艺术亲子活动包加购班级:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.form.ClassNum
    },
    model: {
      value: (_vm.form.MoreClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "MoreClassNum", $$v)
      },
      expression: "form.MoreClassNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置课程"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.courses,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.MoreClassNum > 0),
      expression: "form.MoreClassNum>0"
    }],
    attrs: {
      "label": "配置艺术亲子活动材料包:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.packages,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 20 * _vm.form.MoreClassNum
          },
          on: {
            "change": _vm.changeProNum
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.MoreClassNum > 0),
      expression: "form.MoreClassNum>0"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ConsigneeList !== ''),
      expression: "ConsigneeList!==''"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("修改地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("快递")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("寄付（送货）")])])], 1), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return _c('payTypeInfo', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.price > 0),
        expression: "price>0"
      }],
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    })
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.price > 0),
      expression: "this.price>0"
    }]
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderRemark", $$v)
      },
      expression: "form.OrderRemark"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('schoolList', {
    ref: "refschoolList",
    on: {
      "getSchoolItem": _vm.getSchoolItem
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.getSchoolConsigneeList
    }
  }), _vm._v(" "), _c('optOpenClassDialog', {
    ref: "refoptOpenClassDialog",
    on: {
      "shcoolList": _vm.getSchoolName
    }
  }), _vm._v(" "), _c('addClass', {
    ref: "refAddClass",
    on: {
      "getClassList": _vm.getClassList
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "showClose": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "60px"
    }
  }, [_vm._v("该幼儿园名下暂无班级！")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary ",
      "size": "samll "
    },
    on: {
      "click": _vm.other
    }
  }, [_vm._v("选择其他幼儿园")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary ",
      "size": "samll "
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("创建班级")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06870931!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addSummerSchoolOrder/index.vue
// module id = 1371
// module chunks = 1